(function () {
  // 1) Detectar ?limit= de forma segura (con y sin URLSearchParams)
  var hasLimit = false, limitVal = null;
  try {
    var u = new URL(window.location.href);
    if (u.searchParams.has('limit')) {
      hasLimit = true;
      limitVal = u.searchParams.get('limit');
    }
  } catch (e) {
    if (/\blimit=\d+/i.test(window.location.search || "")) {
      hasLimit = true;
      limitVal = (window.location.search.match(/limit=(\d+)/i) || [])[1] || null;
    }
  }
  if (!hasLimit) return;

  // 2) Upsert meta robots y fusionar con la que ya exista
  function upsertRobots(desired) {
    var m = document.querySelector('meta[name="robots"]');
    if (!m) {
      m = document.createElement('meta');
      m.setAttribute('name', 'robots');
      document.head.appendChild(m);
    }
    var current = (m.getAttribute('content') || '').toLowerCase();
    var parts = new Set(current.split(',').map(s => s.trim()).filter(Boolean));
    desired.split(',').forEach(s => parts.add(s.trim().toLowerCase()));

    // Asegura noindex y, si no hay directiva de follow/no, preferimos follow
    parts.add('noindex');
    parts.add('nofollow');

    m.setAttribute('content', Array.from(parts).join(', '));
  }

  // 3) Ejecutar cuando el <head> está disponible (por si el script carga ultra-pronto)
  if (document.head) {
    upsertRobots('noindex, nofollow');
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      upsertRobots('noindex, nofollow');
    });
  }

  try { console.debug('[SEO] noindex aplicado por ?limit=', limitVal); } catch(e){}
})();
